import {
  ORGANIZATION_ROLE_SYSTEM,
  ORGANIZATION_ROLE_SYSTEM_R5,
  TELECONSULTORIA_AFFILIATION_ROLE,
} from "../constants";

const ACCEPTED_ROLE_SYSTEMS = new Set<string>([
  ORGANIZATION_ROLE_SYSTEM,
  ORGANIZATION_ROLE_SYSTEM_R5,
]);

/**
 * Afiliação de teleconsultoria = algum `code.coding` com code `HIE/HIO`
 * no CodeSystem organization-role.
 *
 * Função pura, usada nos dois sentidos:
 * - fluxos de convênio descartam o que for teleconsultoria;
 * - o módulo de teleconsultoria só aceita o que for teleconsultoria.
 */
export function isTeleconsultoriaAffiliation(
  affiliation: fhir5.OrganizationAffiliation | undefined,
): boolean {
  if (!affiliation?.code?.length) return false;
  return affiliation.code.some((concept) =>
    concept.coding?.some(
      (coding) =>
        coding.code === TELECONSULTORIA_AFFILIATION_ROLE.code &&
        ACCEPTED_ROLE_SYSTEMS.has(coding.system || ""),
    ),
  );
}
